import React, { useState } from 'react';

const CustomerContext = React.createContext([{}, () => {}]);

const CustomerProvider = (props) => {
  const [customer, setCustomer] = useState(props.value)

  return (
    <CustomerContext.Provider value={[customer, setCustomer]}>
      {props.children}
    </CustomerContext.Provider>
  );
};

export { CustomerContext, CustomerProvider}
